<form [formGroup]="frmGroup" (ngSubmit)="onSave()">
    <div class="account-settings-card">
        <h5>Profile</h5>
        <p>Update your photo and personal details here.</p>
        <div class="row">
            <div class="col-sm-6">
                <div class="form-group">
                    <label class="main-label d-block fw-medium text-black">
                        First Name
                        <span class="text-danger">*</span>
                    </label>
                    <input type="text" class="form-control" placeholder="First Name" formControlName="firstNameControl"
                        maxlength="100" />
                </div>
                <div class="form-text text-danger" *ngIf="isSubmitted && f['firstNameControl']!.hasError('required')">
                    First Name is required.
                </div>
                <div class="form-text text-danger"
                    *ngIf="isSubmitted && f['firstNameControl']!.hasError('onlyWhitespace')">
                    First Name can not be only whitespace.
                </div>
            </div>
            <div class="col-sm-6">
                <div class="form-group">
                    <label class="main-label d-block fw-medium text-black">
                        Last Name
                        <span class="text-danger">*</span>
                    </label>
                    <input type="text" class="form-control" type="text" class="form-control" placeholder="Last Name"
                        formControlName="lastNameControl" maxlength="100" />
                </div>
                <div class="form-text text-danger" *ngIf="isSubmitted && f['lastNameControl']!.hasError('required')">
                    Last Name is required.
                </div>
                <div class="form-text text-danger"
                    *ngIf="isSubmitted && f['lastNameControl']!.hasError('onlyWhitespace')">
                    Last Name can not be only whitespace.
                </div>
            </div>
            <div class="col-sm-6">
                <div class="form-group">
                    <label class="main-label d-block fw-medium text-black">Email Address</label>
                    <input type="text" class="form-control" placeholder="Email" formControlName="emailControl"
                        maxlength="200" readonly />
                </div>
            </div>
            <div class="col-sm-6">
                <div class="form-group">
                    <label class="main-label d-block fw-medium text-black">
                        Phone Number
                        <span class="text-danger">*</span>
                    </label>
                    <input type="text" class="form-control" placeholder="Phone Number"
                        formControlName="phoneNumberControl" maxlength="30" />
                </div>
                <div class="form-text text-danger" *ngIf="isSubmitted && f['phoneNumberControl']!.hasError('required')">
                    Phone Number is required.
                </div>
                <div class="form-text text-danger"
                    *ngIf="isSubmitted && f['phoneNumberControl']!.hasError('onlyWhitespace')">
                    Phone Number can not be only whitespace.
                </div>
            </div>
        </div>

        <div class="form-btn-box">
            <button type="button" (click)="toggleClass()"
                class="warn d-inline-block fw-medium border-radius border-0 transition">
                Cancel
            </button>
            <button [disabled]="!formIsValid()"
                class="primary d-inline-block fw-medium border-radius border-0 transition">
                <span class="d-inline-block position-relative">
                    <i class="material-symbols-outlined">check</i>
                    Update Profile
                </span>
            </button>
        </div>
    </div>
</form>